/*
 * @Author: 温少昌 wenshaochang@huizhihuyu.com
 * @Date: 2024-07-23 11:35:56
 * @LastEditors: 温少昌 wenshaochang@huizhihuyu.com
 * @LastEditTime: 2024-07-24 10:30:53
 * @FilePath: /HZ_API/src/utils/getBaseUrl.js
 * @Description: 请求的基础路径
 */
export default function getBaseUrl() {
    // return 'https://cloud.agentsyun.com/api'
    return 'https://cloud.sit.agentsyun.com/api'
}